module.exports = __webpack_public_path__ + "static/logo-709f54dff6eb4d25b45cb2efa674fdd4.png";